import React, { useEffect, useState } from "react";
import config from "../../../config";
import TextArea from "../../TextArea/TextArea";
import "../Modal2.css";
import Input from "../../input/input";
import axios from "../../../utils/Security/axiosInstance";
import { getCustomerCc } from "../../../utils/customerCcMap";
import ses from "../../../Assets/ses.jpg";
import { authFetch } from "../../../utils/Security/authFetch";
import { getSignatureLines } from "../../../utils/emailSignature";

type ConfirmModalProps = {
  data: {
    affectedSite: string;
    affectedLink: string;
    incidentStartDatetime: any;
    incidentCloseDatetime: any;
    summary: string;
    description: string;
    errorType: string;
    closureCode: string;
    solution: string;
    affectedNetwork: string[];
    affectedCustomer?: string[];
    id: string;
    ticketId: string;
    user?: string;
    message?: string;
    responce?: string;
    foruser?: [];
    foruserid?: [];
  };
  onConfirm: () => void;
  onCancel: () => void;
};

const username = localStorage.getItem("username") || "System";
const isAdmin = localStorage.getItem("isAdmin") === "true";
const isForPetrobras = localStorage.getItem("isForPetrobras ") === "true";

const CommunicationModal: React.FC<ConfirmModalProps> = ({
  data,
  onConfirm,
  onCancel,
}) => {
  const [message, setmessage] = useState<string>(data.message || "");
  const [users, setUsers] = useState([]);
  const [msoEmails, setMsoEmails] = useState<string[] | undefined>(undefined);

  const postMessage = async (payload: any) => {
    const res = await authFetch(`${config.apiBaseUrl}/api/communications`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    if (!res.ok) {
      const err = await res.text();
      throw new Error(err || "Failed to post message");
    }

    return res;
  };

  useEffect(() => {
    const fetchEmails = async () => {
      try {
        const response = await authFetch(
          `${config.apiBaseUrl}/api/responsible-person/emails/role2`,
        );
        if (!response.ok) {
          throw new Error("Failed to fetch emails");
        }
        const data = await response.json();

        const allEmails = [...data, "g.kattan@bcomsat.com"];
        const uniqueEmails = Array.from(new Set(allEmails));
        setMsoEmails(uniqueEmails);
      } catch (err: any) {
        console.error("Email fetch failed:", err);
      }
    };

    fetchEmails();
  }, []);

  useEffect(() => {
    if (!data.affectedCustomer) return;

    const fetchUsers = async () => {
      try {
        const response = await axios.get(
          `${config.apiBaseUrl}/api/users/id-by-organization?organization=${data.affectedCustomer}`,
        );
        setUsers(response.data);
      } catch (error) {
        console.error("Error fetching users:", error);
        setUsers([]);
      }
    };

    fetchUsers();
  }, [data.affectedCustomer]);

  // ✅ FIXED: only require the foruserid field, not the full IncidentData
  const fetchcustomerEmails = async (input: {
    foruserid?: [];
  }): Promise<string[]> => {
    const responseEmails = await authFetch(
      `${config.apiBaseUrl}/api/users/email-by-id?id=${input.foruserid}`,
    );
    if (!responseEmails.ok)
      throw new Error(`HTTP error! status: ${responseEmails.status}`);

    return await responseEmails.json();
  };
    const customerCc = getCustomerCc(
        data.affectedCustomer,
        data.affectedNetwork
    );  
  const handleConfirm = async () => {
    if (!message.trim()) {
      alert("Please enter a Message note before submitting.");
      return;
    }

    const username = localStorage.getItem("username") || "System";
    const payload = {
      users: `${username}`,
      message: `${message}`,
      response: ``,
      foruserid: users,
      date: new Date().toISOString(),
      ticketid: data.ticketId,
    };

    if (!isAdmin) {
      try {
        await authFetch(`${config.apiBaseUrl}/api/email/send`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            to: msoEmails,
            subject: `${data.affectedCustomer} Sent you a message ${data.ticketId}.`,
            body: `
              <div style="font-family: Arial, sans-serif; font-size: 14px; color: #333; line-height: 1.6;">
                <p>Hello,</p>
                <p>${
                  data.affectedCustomer
                } is trying to communicate with you:</p>
                   <p><strong>Customer:</strong> ${
                     data.affectedCustomer ?? ""
                   }<br><br>
      <strong>Network:</strong> ${data.affectedNetwork ?? ""}<br><br>
      <strong>Site:</strong> ${data.affectedSite ?? ""}<br><br>
      <strong>Link:</strong> ${data.affectedLink ?? ""}<br><br>
<strong>Incident Start Date:</strong> ${
              data.incidentStartDatetime
                ? data.incidentStartDatetime.replace("T", " ")
                : ""
            }<br><br>


<strong>Incident Close Date:</strong> ${
              data.incidentCloseDatetime
                ? data.incidentCloseDatetime.replace("T", " ")
                : ""
            }<br><br>
  <strong>Summary:</strong> ${data.summary ?? ""}<br><br>
  <strong>Description:</strong> ${data.description ?? ""}<br><br>
  <strong>Error Type:</strong> ${data.errorType ?? ""}<br><br>
  <strong>Closure Code:</strong> ${data.closureCode ?? ""}<br><br>
  <strong>Solution:</strong> ${data.solution ?? ""}<br><br>
    <p>
                <p><strong>Message:</strong> ${message}<br></p>
                <p>Regards,<br><br></p>
               
                <a href=https://bdm.bcomsat.com target="_blank" style="color: #2a1364; font-weight: bold; text-decoration: none;">
                               👉 View Incident Details
                             </a>
                   </p>
               
                    <table cellpadding="0" cellspacing="0" border="0" style="margin-top: 20px;">
                     <tr>
                       <td style="vertical-align: top; padding-right: 12px;">
               
                        <img src="cid:seslogo" alt="SES Logo" style="height:50px;width:auto;" />
                     
               
                       </td>
               
                       <td>
                         <div style="
                           padding: 12px;
                           border-left: 4px solid #2a1364;
                           background-color: #f9f9f9;
                           color: #2a1364;
                           font-size: 13px;
                         ">
                           <strong>Managed Services Operations</strong><br>
                           ${getSignatureLines(data.affectedCustomer, "#2a1364")}
                         </div>
                       </td>
                     </tr>
                   </table>
              </div>
            `,
          }),
        });
      } catch (emailErr) {
        console.error("Failed to send email notification:", emailErr);
      }
    } else if (
      isAdmin &&
      !isForPetrobras &&
      !data.affectedCustomer?.includes("Petrobras")
    ) {
      try {
        const email = await fetchcustomerEmails(data); // ✅ works now
        await authFetch(`${config.apiBaseUrl}/api/email/send`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            to: email,
                 cc: [
                  ...(customerCc ?? []),
                  "support@bcomintelsat.com",
              ],
            subject: `Alert from SES VAS OPS Team | ${
              data.affectedCustomer ?? ""
            } | ${data.ticketId}`,
            body: `
              <div style="font-family: Arial, sans-serif; font-size: 14px; color: #333; line-height: 1.6;">
                <p>Hello,</p>
                <p>Alert from SES VAS OPS Team | ${
                  data.affectedCustomer ?? ""
                } | ${data.ticketId}</p>
                     <p><strong>Customer:</strong> ${
                       data.affectedCustomer ?? ""
                     }<br><br>
      <strong>Network:</strong> ${data.affectedNetwork ?? ""}<br><br>
      <strong>Site:</strong> ${data.affectedSite ?? ""}<br><br>
      <strong>Link:</strong> ${data.affectedLink ?? ""}<br><br>
<strong>Incident Start Date:</strong> ${
              data.incidentStartDatetime
                ? data.incidentStartDatetime.replace("T", " ")
                : ""
            }<br><br>


<strong>Incident Close Date:</strong> ${
              data.incidentCloseDatetime
                ? data.incidentCloseDatetime.replace("T", " ")
                : ""
            }<br><br>
  <strong>Summary:</strong> ${data.summary ?? ""}<br><br>
  <strong>Description:</strong> ${data.description ?? ""}<br><br>
  <strong>Error Type:</strong> ${data.errorType ?? ""}<br><br>
  <strong>Closure Code:</strong> ${data.closureCode ?? ""}<br><br>
  <strong>Solution:</strong> ${data.solution ?? ""}<br><br>
    <p>
                <p><strong>Message:</strong> ${message}<br></p>
                <p>

 <a href=https://bdm.bcomsat.com target="_blank" style="color: #2a1364; font-weight: bold; text-decoration: none;">
                👉 View Incident Details
              </a>
    </p>

     <table cellpadding="0" cellspacing="0" border="0" style="margin-top: 20px;">
      <tr>
        <td style="vertical-align: top; padding-right: 12px;">

         <img src="cid:seslogo" alt="SES Logo" style="height:50px;width:auto;" />
      

        </td>

        <td>
          <div style="
            padding: 12px;
            border-left: 4px solid #2a1364;
            background-color: #f9f9f9;
            color: #2a1364;
            font-size: 13px;
          ">
            <strong>Managed Services Operations</strong><br>
            ${getSignatureLines(data.affectedCustomer, "#2a1364")}
          </div>
        </td>
      </tr>
    </table>
              </div>
            `,
          }),
        });
      } catch (emailErr) {
        console.error("Failed to send email notification:", emailErr);
      }
    } else if (isAdmin && data.affectedCustomer?.includes("Petrobras")) {
      try {
        const email = await fetchcustomerEmails(data);
        await authFetch(`${config.apiBaseUrl}/api/email/send`, {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
               to: ["bernardo.pimenta@petrobras.com.br" ,
            "gabriel.azevedo@petrobras.com.br"],
              cc:  ["marcelo.fiuza@ses.com","Rogerio.Tuyama@ses.com", "Walid.Wehbe2@ses.com", "Ricardo.Moreira@ses.com","Maria.Valle@ses.com" ,"support.latam@bcomintelsat.com","support@bcomintelsat.com"],
            subject: `Alert from SES VAS OPS Team | ${
              data.affectedCustomer ?? ""
            } | ${data.ticketId}`,
            body: `
                  <div style="font-family: Arial, sans-serif; font-size: 14px; color: #333; line-height: 1.6;">
                    <p>Hello,</p>
                    <p>Alert from SES VAS OPS Team | ${
                      data.affectedCustomer ?? ""
                    } | ${data.ticketId}</p>
                         <p><strong>Customer:</strong> ${
                           data.affectedCustomer ?? ""
                         }<br><br>
          <strong>Network:</strong> ${data.affectedNetwork ?? ""}<br><br>
          <strong>Site:</strong> ${data.affectedSite ?? ""}<br><br>
          <strong>Link:</strong> ${data.affectedLink ?? ""}<br><br>
    <strong>Incident Start Date:</strong> ${
      data.incidentStartDatetime
        ? data.incidentStartDatetime.replace("T", " ")
        : ""
    }<br><br>

    <strong>Incident Close Date:</strong> ${
      data.incidentCloseDatetime
        ? data.incidentCloseDatetime.replace("T", " ")
        : ""
    }<br><br>
      <strong>Summary:</strong> ${data.summary ?? ""}<br><br>
      <strong>Description:</strong> ${data.description ?? ""}<br><br>
      <strong>Error Type:</strong> ${data.errorType ?? ""}<br><br>
      <strong>Closure Code:</strong> ${data.closureCode ?? ""}<br><br>
      <strong>Solution:</strong> ${data.solution ?? ""}<br><br>
        <p>
                    <p><strong>Message:</strong> ${message}<br></p>
                    <p>

     <a href=https://bdm.bcomsat.com target="_blank" style="color: #2a1364; font-weight: bold; text-decoration: none;">
                    👉 View Incident Details
                  </a>
        </p>

         <table cellpadding="0" cellspacing="0" border="0" style="margin-top: 20px;">
          <tr>
            <td style="vertical-align: top; padding-right: 12px;">

             <img src="cid:seslogo" alt="SES Logo" style="height:50px;width:auto;" />

            </td>

            <td>
              <div style="
                padding: 12px;
                border-left: 4px solid #2a1364;
                background-color: #f9f9f9;
                color: #2a1364;
                font-size: 13px;
              ">
                <strong>Managed Services Operations</strong><br>
                ${getSignatureLines(data.affectedCustomer, "#2a1364")}
              </div>
            </td>
          </tr>
        </table>
                  </div>
                `,
          }),
        });
      } catch (emailErr) {
        console.error("Failed to send email notification:", emailErr);
      }
    }

    try {
      await postMessage(payload);
      alert("Message Sent Successfully!");
      onConfirm();
    } catch (error) {
      alert(`Failed to Send Message: ${(error as Error).message}`);
    }
  };

  return (
    <div
      className="modal-overlay"
      style={{
        backgroundColor: "rgba(0, 0, 0, 0.5)",
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        zIndex: 9999,
        padding: "1rem",
      }}
    >
      <div
        className="modal-content"
        style={{
          backgroundColor: "#fff",
          padding: "2rem 2.5rem",
          borderRadius: "12px",
          maxWidth: 450,
          width: "100%",
          boxShadow:
            "0 8px 24px rgba(0, 0, 0, 0.15), 0 2px 8px rgba(0, 0, 0, 0.1)",
          display: "flex",
          flexDirection: "column",
          gap: "1.5rem",
          fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
        }}
      >
        {isAdmin && <h4>Communicate with {data.affectedCustomer}</h4>}
        {username}
        <TextArea
          label="Message"
          onChange={setmessage}
          style={{ width: "100%" }}
          value={message}
        />

        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            gap: "1rem",
            marginTop: "1rem",
          }}
        >
          <button
            onClick={onCancel}
            style={{
              padding: "0.5rem 1.2rem",
              borderRadius: "6px",
              border: "1px solid #ccc",
              backgroundColor: "#fff",
              color: "#444",
              cursor: "pointer",
              fontWeight: 500,
              transition: "background-color 0.2s ease",
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.backgroundColor = "#f0f0f0")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.backgroundColor = "#fff")
            }
          >
            Cancel
          </button>

          <button
            onClick={handleConfirm}
            style={{
              padding: "0.5rem 1.5rem",
              borderRadius: "6px",
              border: "none",
              backgroundColor: "#f97316",
              color: "white",
              cursor: "pointer",
              fontWeight: 600,
              boxShadow: "0 4px 8px rgba(249, 115, 22, 0.4)",
              transition: "background-color 0.2s ease",
            }}
            onMouseEnter={(e) =>
              (e.currentTarget.style.backgroundColor = "#c4510b")
            }
            onMouseLeave={(e) =>
              (e.currentTarget.style.backgroundColor = "#f97316")
            }
          >
            Send Message
          </button>
        </div>
      </div>
    </div>
  );
};

export default CommunicationModal;
